enum AllocationRetailerRoutes {
  List = '/allocation/retailer',
  Add = '/allocation/retailer/add',
  Edit = '/allocation/retailer/edit/:id',
}

export default AllocationRetailerRoutes
